const SET_CAP_HISTORICAL_DOCUMENTS = 'SET_CAP_HISTORICAL_DOCUMENTS';
const RESET_CAP_HISTORICAL_DOCUMENTS = 'RESET_CAP_HISTORICAL_DOCUMENTS';

export const CAP_HISTORICAL_DOCUMENTS_ACTION_TYPES = {
    SET_CAP_HISTORICAL_DOCUMENTS,
    RESET_CAP_HISTORICAL_DOCUMENTS,
};
